import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=0a0b1e4f&scoped=true&"
import script from "./MembershipForm.vue?vue&type=script&lang=js&"
export * from "./MembershipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b1e4f",
  null
  
)

export default component.exports